<div *ngrxLet="viewModel$; let value" class="max-w-[386px]">
  @for (markerLocation of value.infoWindowLocations; track trackByFn(i, markerLocation); let i = $index) {

    <div class="flex flex-col grow">
      @if (markerLocation?.location; as location) {

        <div class="flex flex-row min-h-8" [ngClass]="{'mt-4': isCcCandidate(location) && i}">
          <div class="flex items-center justify-center mr-3 min-w-[32px] cursor-pointer relative"
            [ngStyle]="{filter: !isCcCandidate(location) && value.hoveredRowId === location.id || isCcCandidate(location) && value.ccRowSettingsDictionary?.[location.placeId]?.hovered ? 'brightness(90%)' : ''}"
               (mouseenter)="highlightGridRow.emit(markerLocation)"
               (mouseleave)="removeHighlightFromGridRow.emit(markerLocation)"
               (click)="scrollGridRowIntoView.emit(markerLocation)">
            <img
              [src]="value.infoWindowLocations.length > 1 ? getSafeMarkerSvgUrl(markerLocation.url.default) :
                location.logoPhoto ? location.logoPhoto :
                getSafeMarkerSvgUrl(markerLocation.url.default)"
              alt="N/A"
              class="max-h-8"/>
              @if (value.infoWindowLocations.length > 1 || !location.logoPhoto) {
                <span class="markerLabel">{{ markerLocation.label.text }}</span>
              }
          </div>

          <div class="flex flex-col grow min-w-[50px]">
            <span class="text-neutral-10">
              @if (location.businessName) {
                <span class="text-title-small break-words">{{ location.businessName }}&nbsp;</span>
              }
              @if (location.storeCode) {
                <span class="text-body-medium">{{
                    '('
                + location.storeCode + ')' }}</span>
              }
            </span>
            <span class="text-neutral-30 overflow-hidden text-ellipsis">
              @if (location.addressLine1) {
                <span class="text-body-small">{{
                    location.addressLine1
                + ', ' }}</span>
              }
              @if (location.postalCode) {
                <span class="text-body-small">{{
                    location.postalCode
                + ' ' }}</span>
              }
              @if (location.city) {
                <span class="text-body-small">{{
                    location.city
                + ', ' }}</span>
              }
              @if (location.country) {
                <span class="text-body-small">{{ location.country }}</span>
              }
            </span>
          </div>

          <div class="flex items-center justify-start pl-[10px]"
               [ngClass]="{'min-w-[136px]': stretchActionButtonsContainer(value.infoWindowLocations)}">
            <div class="w-10 h-10 flex items-center justify-center">
              @if (location.mapsUrl) {
                <a
                  href="{{ location.mapsUrl }}"
                  target="_blank"
                  rel="noopener noreferrer"
                  matTooltip="Show this location on Google Maps"
                  appGtagEvent
                  trackOn="click"
                  action="open link"
                  category="Navigation [overhaul]"
                  [params]="{event_label: 'Open location in Google Maps'}">
                  <span class="flex justify-center items-center w-6 h-6">
                    <img src="https://storage.googleapis.com/lsc-tmp-images/maps.svg"
                      class="w-[21px] h-[21px]"
                      alt/>
                  </span>
                </a>
              }
              @if (!location.mapsUrl) {
                <span
                  class="opacity-50 grayscale"
                  matTooltip="This location is not on Google Maps">
                  <img src="https://storage.googleapis.com/lsc-tmp-images/maps.svg"
                    class="w-[21px] h-[21px]"
                    alt/>
                </span>
              }
            </div>

            <!-- claim & duplicate action buttons -->
            @if (isCcCandidate(location)) {
              <app-cc-action-buttons
                [placeId]="location.placeId">
              </app-cc-action-buttons>
            }
          </div>
        </div>
      }

      @if (showDivider(value.infoWindowLocations, i, value.focusedLocationId)) {
        <mat-divider class="my-3"></mat-divider>
      }

    </div>
  }

</div>